import React from 'react'
import { useTranslation } from 'react-i18next'
import { IdealAnswerItem, AnswerKeySettings } from '../types'
import QuizTableEditor from '../../OldPortalComponents/QuizTableEditor'

interface TableQuestionProps {
  idealAnswerItems: IdealAnswerItem[]
  answerKeySettings: AnswerKeySettings
  scoredBy: { value: string; label: string }
  onAnswerKeyTableChange: (
    value: IdealAnswerItem[],
    rowCount: number,
    columnCount: number,
  ) => void
  onHeaderChange: (value: string[]) => void
  onColumnHeaderChange: (value: string[]) => void
}

const TableQuestion: React.FC<TableQuestionProps> = ({
  idealAnswerItems,
  answerKeySettings,
  scoredBy,
  onAnswerKeyTableChange,
  onHeaderChange,
  onColumnHeaderChange,
}) => {
  const { t } = useTranslation()

  return (
    <>
      <h4 className="page-subheading">{t('Answer key')}</h4>
      <QuizTableEditor
        onHeaderChange={onHeaderChange}
        onColumnHeaderChange={onColumnHeaderChange}
        onAnswerKeyTableChange={onAnswerKeyTableChange}
        tableValues={idealAnswerItems}
        horizontalHeaderValues={answerKeySettings.headers || ['', '', '']}
        verticalHeaderValues={answerKeySettings.column_headers || ['']}
        enableVerticalHeader={answerKeySettings.enable_column_header || false}
        rowCount={answerKeySettings.row_count || null}
        columnCount={answerKeySettings.column_count || null}
        scoredBy={scoredBy}
      />
    </>
  )
}

export default TableQuestion
